var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 408,
    height: 270,
    viewBox: "0 0 408 270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5167",
    "data-name": "Rectangle 5167",
    width: 408,
    height: 270,
    rx: 12,
    transform: "translate(84 232)",
    fill: "#2a61ad"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10622",
    "data-name": "Group 10622",
    transform: "translate(-84 -216)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5155",
    "data-name": "Rectangle 5155",
    width: 408,
    height: 270,
    rx: 12,
    transform: "translate(84 216)",
    fill: "#2a61ad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_18",
    "data-name": "Mask Group 18",
    transform: "translate(0 -16)",
    opacity: 0.1,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 124.5,
    cy: 124.5,
    r: 124.5,
    transform: "translate(278 23)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.93f0e69be62a5b18d067c6ba14e983e2.svg";
export { ForwardRef as ReactComponent };